import { ValidationResult } from "../types";
export function imageValidator(productOption, hideImagesProp) {
    const result = new ValidationResult();
    // do not hide images by default
    let hideImages = false;
    if (hideImagesProp === true) {
        hideImages = true;
    }
    else {
        const allChoicesHaveImages = productOption.choices.every((choice) => {
            return !!choice.image;
        });
        if (!allChoicesHaveImages) {
            hideImages = true;
            result.addValidation("At least one choice is missing a thumbnail image. `hideImages` flag will be set to true.");
        }
    }
    return {
        messages: result.messages,
        hideImages,
    };
}
//# sourceMappingURL=image-validator.js.map